import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { saveSearch } from "../../store/actions/store";
import { CircularProgress, SwipeableDrawer } from "@material-ui/core";

import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ScrollContainer from "react-indiana-drag-scroll";
import ProductInList from "../Menu/ScrollView/ProductInList";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import instance from "../../store/actions/instance";

const ProductCrossSell = ({
  productID,
  categoryID,
  parentID,
  crossSellCheck,
}) => {
  const dispatch = useDispatch();

  const container = useRef(null);
  const [refVisible, setRefVisible] = useState(false);

  const [loading, setLoading] = useState(false);
  const [crossSellItems, setCrossSellItems] = useState([]);
  const [scrollAble, setScrollAble] = useState(false);

  const language = useSelector((state) => state.store.language);
  const themeColor = useSelector((state) => state.store.store.settings?.dark);
  const settings = useSelector((state) => state.store.store.settings);
  const branch = useSelector((state) => state.branch);
  const usedComponents = useSelector((state) => state.store.used_components);
  const currency = useSelector((state) => state.currency);
  const channel = useSelector((state) => state.promise.src);

  //FETCH CROSS SELL ITEMS IDS
  const fetchCrossSellItemsIDs = async (productID) => {
    try {
      const res = await instance.post("/cross_sell_items/", {
        productID: productID,
      });
      return res.data;
    } catch (err) {
      console.error(err);
    }
  };

  //FETCH CROSS SELL ITEMS
  const searchProducts = async () => {
    try {
      const crossSellResponse = await fetchCrossSellItemsIDs(productID);
      if (crossSellResponse.success && crossSellResponse.data?.length) {
        let res;
        if (
          settings.is_branch_based_ordering &&
          (branch.branch || branch.bdc)
        ) {
          res = await instance.post("/search_products_branch_based/000000/", {
            type: branch.isPickup ? "pickup" : "delivery",
            branch_id: branch.branch,
            bdc_id: !branch.isPickup ? branch.bdc : branch.branch,
            used_components: usedComponents,
            country_code: currency.selected,
            specific_product_ids: crossSellResponse?.data,
            channel: channel,
          });
        } else {
          res = await instance.post("/search_products/000000/", {
            used_components: usedComponents,
            country_code: currency.selected,
            specific_product_ids: crossSellResponse?.data,
            channel: channel,
          });
        }
        if (res.data.products?.length) {
          await dispatch(saveSearch(res.data.products));
          setCrossSellItems(
            res.data.products.sort(
              (a, b) =>
                crossSellResponse.data.indexOf(a.id) -
                crossSellResponse.data.indexOf(b.id)
            )
          );
        }
      } else {
        setCrossSellItems([]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const fetchCrossSellItemsEffect = async () => {
      setLoading(true);
      await searchProducts();
      setLoading(false);
    };
    if (crossSellCheck === undefined) {
      fetchCrossSellItemsEffect(productID);
    }
  }, [productID, container, scrollAble]);

  useEffect(() => {
    if (!refVisible) {
      return;
    }
    if (container.current) {
      let CheckScrollAble =
        container.current.container.current.scrollWidth >
        container.current.container.current.clientWidth;
      if (CheckScrollAble !== scrollAble) {
        setScrollAble(CheckScrollAble);
      }
    }
  }, [container, scrollAble, refVisible]);
  if (!crossSellItems?.length) return null;

  return (
    <>
      <div
        className={"mx-3 mt-4"}
        style={{
          fontWeight: "bold",
          display: "flex",
          cursor: "pointer",
          justifyContent: "space-between",
          flexDirection: language === "arabic" ? "row-reverse" : "row",
        }}
      >
        <p
          style={{
            margin: 0,
          }}
        >
          {language === "arabic" ? "اضف الى طلبك …" : "Recommended with ..."}
        </p>
      </div>

      <div>
        {loading ? (
          <div
            style={{ display: "flex", justifyContent: "center", padding: 15 }}
          >
            <CircularProgress style={{ color: themeColor }} />
          </div>
        ) : (
          <div
            className={`d-flex  align-items-center w-100 border ${
              language === "arabic" ? "flex-row-reverse" : ""
            }`}
            style={{
              background: "white",
              padding: "20px 5px",
            }}
          >
            {scrollAble && (
              <ArrowBackIosIcon
                className="pointer mx-1   "
                style={{
                  marginBottom: "55px",
                  transform: language === "arabic" && "rotateY(180deg)",
                }}
                onClick={() =>
                  (container.current.container.current.scrollLeft += -100)
                }
              />
            )}
            <ScrollContainer
              ref={(el) => {
                container.current = el;
                setRefVisible(!!el);
              }}
              vertical={false}
              style={{
                width: "100%",

                overflowY: "hidden",
                direction: language === "english" ? "ltr" : "rtl",
              }}
              className={`d-flex  ${
                !scrollAble ? "justify-content-center" : ""
              } `}
            >
              {crossSellItems?.map((p, index) => (
                <ProductInList
                  product={p}
                  is_last={index + 1 === crossSellItems}
                  is_first={index === 0}
                  key={"gird_category_item " + p.name + " " + p.id}
                  category_id={p.category_id}
                  fromRecommendations
                />
              ))}
            </ScrollContainer>
            {scrollAble && (
              <ArrowForwardIosIcon
                style={{
                  marginBottom: "55px",
                  transform: language === "arabic" && "rotateY(180deg)",
                }}
                className="mx-1 pointer"
                onClick={() =>
                  (container.current.container.current.scrollLeft += 100)
                }
              />
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default ProductCrossSell;
